/**
 * TagList Component
 * Bordered tag chips matching Figma design:
 * border #f2f0eb, rounded-lg, px-2.5 py-2, 13px text
 */

const DEFAULT_MAX_VISIBLE = 4

interface TagListProps {
  tags: string[]
  maxVisible?: number
  className?: string
}

export function TagList({ tags, maxVisible = DEFAULT_MAX_VISIBLE, className }: TagListProps) {
  if (tags.length === 0) return null

  const visibleTags = tags.slice(0, maxVisible)
  const overflowCount = tags.length - maxVisible

  return (
    <div className={`flex items-center gap-2.5 ${className ?? ""}`}>
      {visibleTags.map(tag => (
        <span
          key={tag}
          className="border border-text-primary rounded-md px-2.5 py-2 text-[13px] text-text-primary leading-[20px] whitespace-nowrap"
        >
          {tag}
        </span>
      ))}
      {overflowCount > 0 && (
        <span className="text-sm text-text-primary leading-[20px]">+{overflowCount}</span>
      )}
    </div>
  )
}
